function BookingdotcomIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.702 3.657c0-2.019-1.659-3.657-3.7-3.657H3.7C1.658 0 0 1.638 0 3.657v11.731c0 2.018 1.658 3.657 3.7 3.657h12.301c2.042 0 3.7-1.64 3.7-3.657V3.657z"
        fill="#0C3B7C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.831h9.84v7.214H0V11.83z"
        fill="#0C3B7C"
      />
      <path
        d="M8.954 12.606l-1.587-.002V10.73c0-.4.157-.61.504-.657h1.083c.772 0 1.271.481 1.271 1.26 0 .8-.486 1.273-1.271 1.274zM7.367 7.548v-.494c0-.432.185-.638.59-.664h.813c.696 0 1.113.412 1.113 1.101 0 .525-.286 1.138-1.088 1.138H7.367V7.548zm3.613 1.871l-.287-.16.25-.211c.293-.248.78-.805.78-1.765 0-1.472-1.154-2.42-2.94-2.42h-2.04V4.86h-.232a.99.99 0 00-.959.972v8.35h3.27c1.987 0 3.269-1.069 3.269-2.724 0-.891-.415-1.653-1.11-2.04z"
        fill="#fff"
      />
    </svg>
  )
}

export default BookingdotcomIcon
